<template>
  <div class="is-fullwidth box" id="containerTable">
    <h2 class="is-size-4" align="left"><b>Campanhas</b></h2>

    <b-table :data="campaigns" v-if="this.campaigns.length != 0">
      <template slot-scope="props">
        <b-table-column field="name" label="Anúncios" header-class="header">
          <div id="campaign">
            <img  
              v-if="props.row.type.split('/')[0] == 'image' && props.row.mediaLink" 
              :src="props.row.mediaLink" 
              class="image is-64x64" />
            <video  
              v-if="props.row.type.split('/')[0] == 'video' && props.row.mediaLink" 
              :src="props.row.mediaLink" 
              preload
              autoplay
              muted="true"
              style=" height:64px" />

            <div id="nameCampaign">
              <p class="has-text-grey">{{ props.row.timeCreated }}</p>
              {{ props.row.name }}
            </div>
          </div>
        </b-table-column>
        <b-table-column
          header-class="header"
          field="is_active, activeToday"
          label="Situação"
        >
          <span
            class="tag is-success"
            v-if="props.row.is_active && props.row.activeToday"
            >Ativo</span
          >
          <span
            class="tag is-light"
            v-else-if="!props.row.is_active && props.row.activeToday"
            >Inativo</span
          >
          <span class="tag is-primary" v-else>Concluido</span>
        </b-table-column>
        <b-table-column
          field="sum"
          label="Total de exibições"
          header-class="header"
        >
          {{ props.row.sum }}
        </b-table-column>
        <b-table-column
          field="start_date, end_date, activeToday"
          label="Período de exibição"
          header-class="header"
        >
          <p
            :class="[
              'is-size-6 tag',
              props.row.activeToday ? 'is-success' : 'is-light'
            ]"
          >
            {{ props.row.start_date }} - {{ props.row.end_date }}
          </p>
        </b-table-column>
      </template>
      <template slot="footer">
        <div colspan="5" align="center">
          <router-link :to="{ path: '/videos' }">Mostrar mais</router-link>
        </div>
      </template>
    </b-table>

    <table class="table is-fullwidth" v-else id="titleTable ">
      <thead>
        <tr id="titleTable">
          <td colspan="3">Anúncios</td>
          <td align="center">Total de exibições</td>
          <td align="center">Período de exibição</td>
        </tr>
      </thead>
    </table>

    <div v-if="this.campaigns.length == 0" id="noneContentTable">
      <span
        >Sem mídias cadastradas?
        <router-link :to="{ path: '/videos' }">Cadastre agora</router-link>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomTable",
  props: {
    campaigns: Array
  }
};
</script>

<style>
#tableCampains img {
  object-fit: cover;
  border-radius: 5px;
}
#noneContentTable {
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
}
#titleTable td {
  color: gray;
  font-size: 0.9rem;
}
#containerTable {
  height: 100%;
}

.header {
  color: gray !important;
}

#campaign {
  display: flex;
  flex-direction: row;
}

#nameCampaign {
  display: flex;
  flex-direction: column;
  margin-left: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/custom/CustomTableCampaign.vue